// eslint-disable-next-line no-control-regex -- control characters are exactly what we reject
const CONTROL = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/;

/** Absurd length or control characters. Empty values are safe. Format is not checked. */
export function isStructurallySafe(
  value: string | null | undefined,
  kind: 'phone' | 'postal' | 'text' = 'text'
): boolean {
  if (value == null || value.trim() === '') return true;
  if (CONTROL.test(value)) return false;
  const trimmed = value.trim();
  if (kind === 'phone') {
    if (trimmed.length > 40) return false;
    const digits = trimmed.replace(/\D/g, '');
    if (digits.length === 0 || digits.length > 15) return false;
  }
  if (kind === 'postal' && trimmed.length > 12) return false;
  return true;
}
